import React, {Component} from "react";
import Recaptcha from "react-google-invisible-recaptcha";
import { connect } from "react-redux";

import history from "@/store/history";
import {ROUTESLIST} from "@/static/urls";
import api, {setErrors} from "@/middlewares/api";
import { reduxForm, reset } from "redux-form";

import ReviewStep1 from "./ReviewStep1";
import ReviewStep3 from "./ReviewStep3";

//data for background-style for all steps:

import MainModal from "@/components/modals/main";

import BgImage from "@/assets/images/pages/reviews_bg_img.jpg";
import {v4 as uuidV4} from 'uuid';
import {addToCart, clearCart} from '@/services/cart';
import {devFormDefaults} from '@/utils/devFormDefaults';
import {oneTimePlans} from '@/utils/constants';

const bgStyles = {
    backgroundImage: `url(${BgImage})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
};

export class SampleReviewWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            isOpenModal: false,
            sending: false,
            isOpenDisclaimer: false,
            isCheckedDisclaimer: false,
            formData: devFormDefaults('review')
        };
        this.isRecaptcha = !!process.env.REACT_APP_RECAPTCHA_KEY;
        this.recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
    }

    handleStep1Submit = (data) => {
        // This is only called when Step 1 was valid! Skip step 2, go directly to step 3
        // Reset step 3 form to clear any previous touched/error state
        // this.props.dispatch(reset('sampleReviewStep3')); // Only reset when navigating backward
        this.setState(prevState => ({step: 3, formData: {...prevState.formData, ...data}}));
    };

    handleStep3Submit = (values) => {
        // Gather all localStorage data for a final review object
        const allDraft = JSON.parse(localStorage.getItem("ample_sample_review_draft")) || {};


        const plan = oneTimePlans.find(plan => plan.id === 'single-sample-review');
        // Single base product: the server resolves membership + credits and applies the discount.
        const finalReviewObj = {
            ...allDraft,
            ...values, // step 3 values are the latest
            ...this.state.formData,
            ...plan,
            id: uuidV4(),
            product_type: 'review'
        };
        clearCart();
        addToCart(finalReviewObj);
        localStorage.removeItem("ample_sample_review_draft")
        // Go to checkout
        history.push(ROUTESLIST.CHECKOUT, {from: 'sample-review'});
    };

    handleStep3Prev = () => {
        // Go back to step 1, skipping step 2
        // Reset step 3 form to clear touched/error state
        this.props.dispatch(reset('sampleReviewStep3'));
        this.setState({step: 1});
    };

    // Modal and Disclaimer logic as in your original
    closeModal = () => {
        this.setState({isOpenModal: false});
        this.props.reset();
        history.push(ROUTESLIST.CHECKOUT, {from: 'sample-review'});
    };

    closeDisclaimer = () => this.setState({isOpenDisclaimer: false});
    openDisclaimer = () => this.setState({isOpenDisclaimer: true});
    disclaimerChange = () =>
        this.setState((prevState) => ({isCheckedDisclaimer: !prevState.isCheckedDisclaimer}));

    // Step navigation
    nextStep = () => this.setState(prev => ({step: prev.step + 1}));
    prevStep = () => this.setState(prev => ({step: prev.step - 1}));

    // Where you manage your cart

    // Submission logic: uses original recaptcha & addToCart setup
    recaptchaSubmit = (data) => {
        return new Promise((resolve, reject) => {
            this.recaptcha.execute().then(() => {
                this.setState({sending: true});
                api.post("sample-review", data)
                    .then(() => this.setState({isOpenModal: true, sending: false}, resolve))
                    .catch(err => {
                        this.setState({sending: false});
                        if (!err.response) return;
                        if (err.response.status === 422) return reject(setErrors(err.response));
                    });
            }).catch(() => resolve(null));
        });
    };

    // Rendering steps with layout
    renderStep() {
        if (this.state.step === 3) {
            return (
                <ReviewStep3
                    onSubmit={this.handleStep3Submit}
                    onPrev={this.handleStep3Prev}
                    initialValues={this.state.formData}
                />
            );
        }
        if (this.state.step === 1) {
            // Note: redux-form passes handleSubmit as a prop
            return (
                <ReviewStep1 onSubmit={this.handleStep1Submit} initialValues={this.state.formData}/>
            );
        }
        return null;
    }

    render() {
        const {isOpenModal, isOpenDisclaimer, isCheckedDisclaimer} = this.state;
        const {isRecaptcha, recaptchaKey} = this;

        return (
            <main className="page upload-page">
                <section className="upload-form__sec" style={bgStyles}>
                    <div className="content">
                        <div className="upload-form__top">
                            <h2 className="head-shadow">Sample Review</h2>
                            <h3 className="head">REVIEW YOUR SAMPLES QUICKLY & ACCURATELY</h3>
                            <div className="upload-form__top-msg form-layout">
                                <p>We answer the who, what, when, where, how and why of samples.</p>
                            </div>
                            <div className="review-video">
                                <div className="review-video__inner">
                                    <iframe
                                        src="https://www.youtube.com/embed/BDBd79wb_jI?si=i-4mL1TSMjkN3qcc"
                                        title="YouTube video player"
                                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        style={{ border: 'none' }}
                                        width="100%"
                                        height="100%"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                        <div
                            className="form-layout"
                        >
                            {this.renderStep()}
                            <div className="submit-row_txt">
                                <p className="as-text">Please read our <button type="button" className="link-thin"
                                                                               onClick={this.openDisclaimer}> disclaimer </button> in
                                    order to submit your request
                                </p>
                            </div>
                            {/* <div className="submit-row__btn-col">
                    {step > 1 && (
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={this.prevStep}
                        disabled={sending || submitting}
                      >Back</button>
                    )}
                    {step == 3 (
                      <button
                        className="btn-red-primary"
                        disabled={submitting || sending || !isCheckedDisclaimer}
                        type="submit"
                      >SEND</button>
                    )}
                  </div> */}
                        </div>
                    </div>
                </section>
                {isRecaptcha && (
                    <Recaptcha
                        style={{display: "none"}}
                        ref={ref => (this.recaptcha = ref)}
                        sitekey={recaptchaKey}
                        onResolved={this.onRecaptchaResolved}
                    />
                )}
                <MainModal open={isOpenModal} onClose={this.closeModal}>
                    <h4 className="main-modal__big-head">YOUR REQUEST IS SENT</h4>
                    <p className="main-modal__subhead">WE WILL BE IN TOUCH WITH YOU WITHIN A HOUR</p>
                    <div className="main-modal__act">
                        <button className="btn btn-primary" type="button" onClick={this.closeModal}>OK</button>
                    </div>
                </MainModal>
                <MainModal open={isOpenDisclaimer} onClose={this.closeDisclaimer}>
                    <p className="main-modal__msg single">
                        The content of our sample review reports are for informational
                        purposes only and should not be taken as legal advice. Such content
                        is based solely upon information provided to us and/or our internal
                        professional analysis. Your reliance on any such content shall be
                        solely at your own risk. ** Nothing in our reports shall absolve you
                        of any obligations to obtain sample licenses and consents, and/or
                        make any payments in connection therewith. You shall hold Ample
                        Samples, Inc. harmless of any wrongdoing which is based on our
                        sample review reports.
                    </p>
                    <p className="main-modal__msg single">
                        <label className="checkbox-field">
                            <input
                                type="checkbox"
                                className="checkbox-field__input"
                                checked={isCheckedDisclaimer}
                                onChange={this.disclaimerChange}
                            />
                            <span className="checkbox-field__control"/>
                            <span className="checkbox-field__label">I accept</span>
                        </label>
                    </p>
                    <div className="main-modal__act">
                        <button className="btn btn-primary" type="button" onClick={this.closeDisclaimer}>OK</button>
                    </div>
                </MainModal>
            </main>
        );
    }
}



const connectedWizard = connect()(SampleReviewWizard);
export default reduxForm({form: "upload-review"})(connectedWizard);